<loader-modal *ngIf="loader"></loader-modal>
<ion-content
  [hidden]="loader"
  class="one3d-visualizer-wrapper"
  [ngClass]="{'one3d-lhs-panel-open': menuVisible}"
  (click)="removeTutorial()"
>
  <ion-row [hidden]="!showData" class="one-3d-fullHeight one3d-visualizer-row">
    <!-- LHS Panel (Left column) -->
    <ion-col
      class="one3d-visualizer-lhs ion-no-padding"
      [ngClass]="{'one-3d-disabled-pointer-events': accessoryLoading}"
      sizeXs="12"
      [sizeLg]="menuVisible ? 3 : 0"
    >
      <!-- one3d-nudge-blur to activate blur for test drive nudge  -->
      <!-- <div *ngIf="showTestDriveNudge" class="one3d-nudge-blur"></div> -->
      <div class="one3d-lhs-panel-wrapper">
        <configurator-header
          *ngIf="globalService.getDeviceType() !== 'mobile'"
          [hidden]="!showHeader && globalService.configurator"
        ></configurator-header>
        <ion-accordion-group
          #vsAccordion
          class="one3d-scrollable-wrapper one3d-acc-wrapper"
          *ngIf="!globalService.configurator"
          value="features"
        >
          <ion-accordion
            value="features"
            toggleIcon="chevron-forward"
            [hidden]="globalService.model?.model_code === 'COMPASS'"
          >
            <ion-item
              (click)="openFeatures()"
              lines="none"
              class="one3d-accordion-item"
              [ngClass]="{'one3d-accordion-item-selected': vsAccordion?.value === 'features'}"
              slot="header"
            >
              <ion-label class="one3d-accordion-label" translate
                >VISUALIZER.FEATURES</ion-label
              >
            </ion-item>
            <ion-card-content slot="content" class="one3d-feature-wrapper">
              <feature></feature>
            </ion-card-content>
          </ion-accordion>
          <ion-accordion value="variants" toggleIcon="chevron-forward">
            <ion-item
              (click)="sendReportAnalytics()"
              [ngClass]="{'one3d-accordion-item-selected': vsAccordion?.value === 'variants'}"
              lines="none"
              class="one3d-accordion-item"
              slot="header"
            >
              <ion-label class="one3d-accordion-label">
                <h4 class="one3d-accordion-variant-label" translate>
                  VISUALIZER.VARIANT
                </h4>
                <p class="one3d-accordion-variant-selected">
                  {{selectedVariant?.variant_name}}
                </p>
              </ion-label>
            </ion-item>
            <ion-card-content slot="content">
              <variants></variants>
            </ion-card-content>
          </ion-accordion>
        </ion-accordion-group>
        <ion-accordion-group
          #ccAccordion
          *ngIf="globalService.configurator"
          [hidden]="!showHeader"
          [value]="activeTab"
          [ngClass]="{'one3d-lowerBrightness': viewBreakup, 'one3d-hide-accordion-group': !showHeader}"
          class="one3d-scrollable-wrapper-custom"
        >
          <ion-accordion value="variant" (click)="openAccordion('variant')">
            <ion-item
              class="one3d-accordion-item"
              slot="header"
              [ngClass]="{'one3d-accordion-item-selected': ccAccordion?.value === 'variant'}"
            >
              <ion-label class="one3d-accordion-label">
                <h4 class="one3d-accordion-variant-label">VARIANT</h4>
                <p class="one3d-accordion-variant-selected">
                  {{globalService.selectedVariant?.variant_name}}
                </p>
              </ion-label>
            </ion-item>
            <ion-card-content class="one3d-bottom-padding-0" slot="content">
              <variants></variants>
            </ion-card-content>
          </ion-accordion>
          <ion-accordion class="ion-hide-lg-down" value="accessories">
            <ion-item
              (click)="openAccordion('accessories')"
              class="one3d-accordion-item"
              [ngClass]="{'one3d-accordion-item-selected': ccAccordion?.value === 'accessories'}"
              lines="none"
              slot="header"
            >
              <ion-label class="one3d-accordion-label">ACCESSORISE</ion-label>
            </ion-item>
            <ion-card-content class="one3d-top-padding-0" slot="content">
              <accessories></accessories>
            </ion-card-content>
          </ion-accordion>
          <ion-accordion
            class="ion-hide-lg-down"
            value="addOns"
            *ngIf="!globalService.disableAddons"
          >
            <ion-item
              (click)="openAccordion('addOns')"
              class="one3d-accordion-item"
              [ngClass]="{'one3d-accordion-item-selected': ccAccordion?.value === 'addOns'}"
              lines="none"
              slot="header"
            >
              <ion-label class="one3d-accordion-label">ADD-ONS</ion-label>
            </ion-item>
            <ion-card-content slot="content">
              <add-ons></add-ons>
            </ion-card-content>
          </ion-accordion>
          <div class="one3d-acc-label-mobile ion-hide-lg-up">
            <ion-item
              (click)="openAccessories()"
              class="one3d-accordion-item"
              lines="none"
              slot="header"
            >
              <ion-label class="one3d-accordion-label">ACCESSORISE</ion-label>
              <ion-icon
                class="one3d-acc-label-right-arrow"
                name="chevron-forward"
              ></ion-icon>
            </ion-item>
          </div>
          <div
            class="one3d-acc-label-mobile ion-hide-lg-up"
            *ngIf="!globalService.disableAddons"
          >
            <ion-item
              (click)="openAddons()"
              class="one3d-accordion-item"
              lines="none"
              slot="header"
            >
              <ion-label class="one3d-accordion-label">ADD-ONS</ion-label>
              <ion-icon
                class="one3d-acc-label-right-arrow"
                name="chevron-forward"
              ></ion-icon>
            </ion-item>
          </div>
        </ion-accordion-group>
        <accessories
          class="ion-hide-lg-up"
          (close)="closeAccessories()"
          *ngIf="!hideAccessories && globalService.configurator"
          mobile="mobile"
        >
        </accessories>
        <add-ons
          class="ion-hide-lg-up"
          (close)="closeAddons()"
          *ngIf="!hideAddons && globalService.configurator"
          mobile="mobile"
        ></add-ons>
      </div>
      <div class="one3d-disclaimer-wrapper-mobile ion-hide-lg-up">
        <div class="one3d-disclaimer-content">
          <p class="one3d-disclaimer-para" translate>VISUALIZER.NOTE</p>
        </div>
        <div class="one3d-disclaimer-btns">
          <button
            (click)="globalService.openPrivacyPolicy()"
            class="one3d-disclaimer-btn"
            translate
          >
            VISUALIZER.PRIVACY_POLICY
          </button>
        </div>
      </div>
    </ion-col>
    <!-- LHS Panel Hide/Show buttons(old-design) -->
    <div
      *ngIf="!hideMenuButtons && globalService.idea == 0"
      class="one3d-lhs-panel-control-wrapper"
    >
      <div class="one3d-lhs-panel-close-wrapper">
        <div
          (click)="toggleMenu()"
          *ngIf="!menuVisible"
          class="one3d-lhs-panel-control one3d-lhs-panel-close ion-hide-lg-down"
        >
          <span class="one3d-lhs-open">
            {{'VISUALIZER.EXPLORE' | translate}}
            {{globalService.model?.model_name}}
          </span>
        </div>
        <button
          (click)="toggleMenuForMobile()"
          *ngIf="!menuVisibleMobile"
          [hidden]="viewBreakup"
          class="one3d-lhs-panel-close-mobile ion-hide-lg-up"
        >
          <span>
            <ion-icon name="caret-up"></ion-icon>
          </span>
          {{'VISUALIZER.EXPLORE' | translate}}
          {{globalService.model?.model_name}}
        </button>
      </div>
      <div class="one3d-lhs-panel-control-wrapper one3d-lhs-panel-open-wrapper">
        <div
          class="one3d-lhs-panel-control one3d-lhs-panel-open ion-hide-lg-down"
          [hidden]="viewSummary"
          (click)="toggleMenu()"
          *ngIf="menuVisible"
        >
          <span class="one3d-lhs-close" translate>VISUALIZER.HIDE_MENU</span>
        </div>
        <button
          *ngIf="menuVisibleMobile"
          [hidden]="viewBreakup"
          (click)="toggleMenuForMobile()"
          class="one3d-lhs-panel-open-mobile ion-hide-lg-up"
        >
          <span>
            <ion-icon name="caret-down"></ion-icon>
          </span>
          {{'VISUALIZER.HIDE_MENU' | translate}}
        </button>
      </div>
    </div>
    <!-- LHS Panel Hide/Show buttons(new-design) -->
    <div
      *ngIf="!hideMenuButtons && globalService.idea != 0"
      class="one3d-lhs-panel-control-wrapper one3d-white-bottom-toggle one3d-chevron-bottom"
    >
      <div class="one3d-lhs-panel-close-wrapper">
        <div
          (click)="toggleMenu()"
          *ngIf="!menuVisible"
          class="one3d-lhs-panel-control one3d-lhs-panel-close ion-hide-lg-down"
        >
          <span class="one3d-lhs-open">
            {{'VISUALIZER.EXPLORE' | translate}}
            {{globalService.model?.model_name}}
          </span>
        </div>
        <button
          (click)="toggleMenuForMobile()"
          *ngIf="!menuVisibleMobile"
          [hidden]="viewBreakup"
          class="one3d-lhs-panel-close-mobile ion-hide-lg-up"
        >
          <span>
            <ion-icon name="caret-up"></ion-icon>
          </span>
          <!-- {{'VISUALIZER.EXPLORE' | translate}} -->
          <!-- {{globalService.model?.model_name}} -->
        </button>
      </div>
      <div class="one3d-lhs-panel-control-wrapper one3d-lhs-panel-open-wrapper">
        <div
          class="one3d-lhs-panel-control one3d-lhs-panel-open ion-hide-lg-down"
          [hidden]="viewSummary"
          (click)="toggleMenu()"
          *ngIf="menuVisible"
        >
          <span class="one3d-lhs-close" translate>VISUALIZER.HIDE_MENU</span>
        </div>
        <button
          *ngIf="menuVisibleMobile"
          [hidden]="viewBreakup"
          (click)="toggleMenuForMobile()"
          class="one3d-lhs-panel-open-mobile ion-hide-lg-up one3d-white-bottom-toggle-btn"
        >
          <span>
            <ion-icon name="caret-down"></ion-icon>
          </span>
          <!-- {{'VISUALIZER.HIDE_MENU' | translate}} -->
        </button>
      </div>
    </div>
    <!-- Tutorial Overlay -->
    <div *ngIf="showTutorial" class="one3d-tutorial-wrapper">
      <div class="one3d-tutorial">
        <div class="one3d-tutorial-gif">
          <!-- <img src="assets/img/one3d-tutorial-desktop.gif" alt="Tutorial GIF"> -->
        </div>
        <div class="one3d-tutorial-content">
          <h4 class="one3d-tutorial-title">
            {{'VISUALIZER.EXPLORE' | translate}}
            {{globalService.model?.model_name}}
          </h4>
          <p class="one3d-tutorial-para">
            Click on “Explore {{globalService.model?.model_name}}" and get to
            know the features and different variants present in
            {{globalService.model?.model_name}}.
          </p>
        </div>
        <button
          (click)="closeTutorial()"
          class="one3d-tutorial-close"
          translate
        >
          VISUALIZER.CLOSE
        </button>
      </div>
    </div>
    <!-- Canvas Panel (Right column) -->
    <ion-col
      class="one3d-canvas-column ion-no-padding"
      sizeXs="12"
      [sizeLg]="menuVisible ? 9 : 12"
      color="dark"
    >
      <one3d></one3d>
      <colors
        [hidden]="hideColorPallette || globalService.viewInterior || hideMenuButtons"
        [menuVisible]="menuVisibleMobile"
      ></colors>
      <!-- show trims in int if available -->
      <trims
        [hidden]="hideTrimPallette || hideMenuButtons || !globalService.viewInterior"
        [menuVisible]="menuVisibleMobile"
      >
      </trims>
      <!-- microinteraction panel on VS -->
      <!-- <div class="one3d-mi-wrapper" *ngIf="globalService.idea == 0">
        <microinteraction-panel
          [hidden]="hideInteractions || hideMenuButtons || globalService.configurator"
        ></microinteraction-panel>
      </div> -->
      <!-- microinteraction panel on VS new-design  -->
      <div class="one3d-mi-wrapper one3d-micro-panel-bottom one3d-mobile">
        <microinteraction-panel
          [hidden]="hideInteractions || hideMenuButtons || globalService.configurator"
        ></microinteraction-panel>
      </div>
      <!-- book a test drive button for desktop-->
      <div
        class="one3d-test-drive-wrap-new"
        [hidden]="showResetButton || hideInteractions || hideMenuButtons"
      >
        <div class="one3d-test-drive-box-new">
          <div class="one3d-test-drive-btn-new">
            <button (click)="testDrive()">
              {{ "VISUALIZER.REQUEST_TEST_DRIVE" | translate }}
            </button>
            <!-- <button (click)="reserveVehicle()" *ngIf="globalService.model?.lms_integrated_code === 'JJ24'">
              RESERVE YOUR VEHICLE
            </button> -->
          </div>
          <!-- <div class="one3d-nudge-test-drive-new">
            <p><span>Book a test drive</span> to experience your JEEP!</p>
            <div class="one3d-nudge-close">
              <img
                src="assets/img/icons/one3d-cross-icon.svg"
                alt="cross-icon"
              />
            </div>
          </div> -->
        </div>
      </div>
      <!-- test-drive-old-btn -->
      <div
        class="one3d-book-test-drive-btn-mobile"
        [hidden]="showResetButton || hideInteractions || hideMenuButtons"
        *ngIf="globalService.idea == 0"
      >
        <div class="one3d-book-test-drive-btn-mobile-box" (click)="testDrive()">
          <div class="icon">
            <img
              src="assets/img/icons/one3d-test-drive-new-icon.svg"
              alt="cross-icon"
            />
          </div>
          <div class="title">
            BOOK A <br />
            TEST DRIVE
          </div>
        </div>
        <!-- <div class="one3d-book-test-drive-btn-mobile-box" *ngIf="globalService.model?.lms_integrated_code === 'JJ24'" (click)="reserveVehicle()">
          <div class="icon">
            <img
              src="assets/img/icons/one3d-test-drive-new-icon.svg"
              alt="cross-icon"
            />
          </div>
          <div class="title">
            Reserve your<br />
            vehicle
          </div>
        </div> -->
      </div>
      <!-- ext/int btn on vs & cc mobile new design -->
      <!-- <interior-exterior-buttons
        *ngIf="globalService.idea != 0"
        [hidden]="!menuVisible || hideMenuButtons"
        [ngClass]="{'events-disabled': accessoryLoading}"
      ></interior-exterior-buttons> -->
      <!-- ext/int button on CC old design-->
      <interior-exterior-buttons
        [hidden]="!globalService.configurator"
        [ngClass]="{'events-disabled': accessoryLoading}"
      ></interior-exterior-buttons>
      <!-- 360 icon button to reset -->
      <div *ngIf="showResetButton">
        <button
          *ngIf="!this.globalService.imageAccessoryOpen"
          (click)="resetToDefaultPosition()"
          class="one3d-reset-position-btn ion-hide-lg-up"
        >
          <span>
            View in
            <span>
              <img
                src="assets/img/icons/one3d-360-icon.svg"
                alt="360 degree icon"
              />
            </span>
          </span>
        </button>
        <button
          *ngIf="this.globalService.imageAccessoryOpen"
          (click)="resetToDefaultPosition()"
          class="one3d-acc-close-btn ion-hide-lg-up"
        >
          <img
            src="assets/img/icons/one3d-acc-close-icon.svg"
            alt="close icon"
          />
          Close
        </button>
      </div>
      <!-- Disclaimer & policy -->
      <div class="one3d-disclaimer-wrapper ion-hide-lg-down">
        <div class="one3d-disclaimer-content">
          <p class="one3d-disclaimer-para" translate>VISUALIZER.NOTE</p>
        </div>
        <div class="one3d-disclaimer-btns">
          <button
            (click)="globalService.openPrivacyPolicy()"
            class="one3d-disclaimer-btn"
            translate
          >
            VISUALIZER.PRIVACY_POLICY
          </button>
        </div>
      </div>
      <div
        class="packIcon packIcon2"
        *ngIf="defaultPack?.length"
        [hidden]="globalService.getDeviceType() === 'mobile' && !menuVisibleMobile"
      >
        <div
          class="packIconrow"
          *ngIf="defaultPack[0]?.pack_mesh_code === 'ADVENTURE_PACK'"
        >
          <img src="assets/img/icons/pack-upland-logo.svg" alt="" />
        </div>
        <div
          class="packIconrow"
          *ngIf="defaultPack[0]?.pack_mesh_code === 'URBAN_PACK'"
        >
          <img src="assets/img/icons/pack-x-logo.svg" alt="" />
        </div>
      </div>
    </ion-col>
  </ion-row>
  <!-- for vs -->
  <ion-row
    [hidden]="!showData"
    class="one3d-lhs-bottom-selected-mobile"
    *ngIf="!globalService.configurator"
  >
    <configurator-header
      *ngIf="globalService.getDeviceType() == 'mobile'"
    ></configurator-header>
    <ion-col
      *ngIf="!hideMenuButtons && globalService.idea == 0"
      sizeXs="12"
      size-md="0"
      class="one3d-lhs-bottom-wrapper ion-no-padding"
    >
      <div class="one3d-lhs-bottom-selected">
        <div class="one3d-lhs-bottom-details">
          <h4 class="one3d-lhs-bottom-title">
            {{selectedVariant?.variant_name}}
          </h4>
          <p class="one3d-lhs-bottom-price">
            {{ globalService.currencyFormatter(
            globalService.selectedConfigPrice?.drive_away_price +
            accessoriesService.updateAccessoryPrice().packs)}}
            <span>{{'VISUALIZER.DRIVE_AWAY_PRICE' | translate}} *</span>
          </p>
        </div>
        <div class="one3d-lhs-bottom-btn">
          <button
            [ngClass]="{'disabled-button-change': vsAccordion?.value == 'variants'}"
            (click)="changeVariantMobile()"
          >
            <span>
              <img
                src="assets/img/icons/one3d-change-icon.svg"
                alt="change button icon"
              />
            </span>
            {{'VISUALIZER.CHANGE' | translate}}
          </button>
        </div>
      </div>
    </ion-col>
    <!-- new-menu-bar-design -->
    <ion-col
      *ngIf="!hideMenuButtons && globalService.idea != 0"
      sizeXs="12"
      size-md="0"
      class="one3d-lhs-bottom-wrapper ion-no-padding one3d-menubar-black"
    >
      <div class="one3d-lhs-bottom-selected one3d-bg-dark">
        <div class="one3d-lhs-bottom-details">
          <h4 class="one3d-lhs-bottom-title">
            <span class="one3d-variant-name-visualizer">
              {{selectedVariant?.variant_name}}
            </span>
            <button
              class="one3d-change-variant-button"
              [ngClass]="{'disabled-button-change': vsAccordion?.value == 'variants'}"
              (click)="changeVariantMobile()"
            >
              <span>
                <img
                  src="assets/img/icons/one3d-yellow-edit.svg"
                  alt="change button icon"
                />
              </span>
              {{'VISUALIZER.CHANGE' | translate}}
            </button>
          </h4>
          <p class="one3d-lhs-bottom-price">
            {{ globalService.currencyFormatter(
            globalService.selectedConfigPrice?.drive_away_price)}}
            <span>{{'VISUALIZER.DRIVE_AWAY_PRICE' | translate}} *</span>
          </p>
        </div>
        <!-- 2nd-idea-animation-test-drive-btn -->
        <div
          *ngIf="globalService.idea == 2 || globalService.idea == 4"
          class="one3d-book-test-drive-btn-mobile one3d-rhs-header-btn"
        >
          <div
            class="one3d-book-test-drive-btn-mobile-box one3d-new-td-btn one3d-test-drive-btn-only"
            (click)="testDrive()"
          >
            <div class="icon rotate">
              <img
                src="assets/img/icons/one3d-test-drive-new-icon.svg"
                alt="cross-icon"
              />
            </div>
            <div class="title">TEST DRIVE</div>
          </div>
          <!-- <div
            class="one3d-book-test-drive-btn-mobile-box one3d-new-td-btn"
            (click)="reserveVehicle()"
            *ngIf="globalService.model?.lms_integrated_code === 'JJ24'"
          >
            <div class="icon rotate">
              <img
                src="assets/img/icons/one3d-test-drive-new-icon.svg"
                alt="cross-icon"
              />
            </div>
            <div class="title">RESERVE VEHICLE</div>
          </div> -->
        </div>
        <div
          class="one3d-nudge top-right one3d-mobile-nudge"
          *ngIf="showTestDriveNudge"
        >
          <p>Join <b>16,000+</b> others who've experienced test drives!</p>
          <!-- <p *ngIf="globalService.model?.lms_integrated_code === 'JJ24'">Reserve your Jeep Avenger today</p> -->
          <img
            (click)="closeTestDriveNudge()"
            src="assets/img/icons/one3d-cross-icon-nudge.svg"
            alt="cross-icon"
          />
        </div>
        <!-- 1st idea-test-drive-btn(without-icon) -->
        <div
          *ngIf="globalService.idea == 1"
          class="one3d-book-test-drive-btn-mobile one3d-rhs-header-btn one3d-shimmer-text"
        >
          <div
            class="one3d-book-test-drive-btn-mobile-box one3d-new-td-btn"
            (click)="testDrive()"
          >
            <div class="title">TEST DRIVE</div>
          </div>
        </div>
        <!-- 3rd idea-offer-btn -->
        <div
          *ngIf="globalService.idea == 3 && globalService.show_offer === 'yes'"
          class="one3d-rhs-header-btn one3d-offer-btn-mobile"
        >
          <div class="offer-btn" (click)="showAusOffers()">
            <span
              ><img
                src="assets/img/icons/one3d-offer-logo.svg"
                alt="offer-icon"
            /></span>
            <div class="title">OFFERS</div>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
  <ion-row
    [hidden]="!showData"
    class="one3d-lhs-bottom-selected-desktop"
    *ngIf="!globalService.configurator"
  >
    <ion-col sizeXs="12" class="one3d-lhs-bottom-wrapper ion-no-padding">
      <div class="one3d-lhs-bottom-selected">
        <div class="one3d-lhs-bottom-details">
          <h4 class="one3d-lhs-bottom-title">
            {{selectedVariant?.variant_name}}
          </h4>
          <p class="one3d-lhs-bottom-price">
            {{ globalService.currencyFormatter(
            globalService.selectedConfigPrice?.drive_away_price +
            accessoriesService.updateAccessoryPrice().packs)}}
            <span>{{'VISUALIZER.DRIVE_AWAY_PRICE' | translate}} *</span>
          </p>
        </div>
        <div class="one3d-lhs-bottom-btn">
          <button
            [ngClass]="{'disabled-button-change': vsAccordion?.value == 'variants'}"
            (click)="changeVariant()"
          >
            <span
              ><img
                src="assets/img/icons/one3d-change-icon.svg"
                alt="change button icon"
            /></span>
            {{'VISUALIZER.CHANGE' | translate}}
          </button>
        </div>
      </div>
      <!-- Bottom CTA panel for idea 0,1,2,3 desktop & idea 1,2 mobile -->
      <ion-row
        *ngIf="globalService.idea == 0 || globalService.idea == 1 || globalService.idea == 2 || globalService.idea == 4 || (globalService.idea == 3 &&  globalService.getDeviceType() !== 'mobile')"
        class="one3d-lhs-btn-row"
      >
        <ion-col
          *ngIf="globalService.show_offer === 'yes'"
          class="ion-no-padding col-6-remove-space"
          size="6"
        >
          <ion-button
            (click)="showAusOffers()"
            class="one3d-lhs-btn one3d-lhs-test-btn"
            expand="full"
            fill="solid"
            translate
          >
            VISUALIZER.VIEW_OFFERS
            <span>
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </span>
          </ion-button>
        </ion-col>
        <ion-col
          [ngClass]="{ 'full-btn': globalService.show_offer === 'no' }"
          class="ion-no-padding col-6-remove-space"
          size="6"
        >
          <ion-button
            (click)="navigateToConfigurator()"
            class="one3d-lhs-btn one3d-lhs-book-btn"
            expand="full"
            translate
          >
            VISUALIZER.CONFIGURE
            <span>
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </span>
          </ion-button>
        </ion-col>
      </ion-row>
      <!--3rd idea of new design for mobile -->
      <ion-row
        *ngIf="globalService.idea == 3 && globalService.getDeviceType() === 'mobile'"
        class="one3d-lhs-config-btn-row"
      >
        <ion-col class="ion-no-padding col-6-remove-space" size="6">
          <ion-button
            class="one3d-lhs-config-btn one3d-lhs-config-left-btn"
            expand="full"
            fill="solid"
            (click)="navigateToConfigurator()"
            translate
          >
            VISUALIZER.CONFIGURE
            <span>
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </span>
          </ion-button>
        </ion-col>
        <ion-col
          class="ion-no-padding col-6-remove-space one3d-blur-btn-td"
          size="6"
        >
          <ion-button
            (click)="testDrive()"
            class="one3d-lhs-config-btn one3d-lhs-config-right-btn"
            expand="full"
          >
            BOOK A TEST DRIVE
            <span>
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </span>
          </ion-button>
        </ion-col>
        <!-- *ngIf="showTestDriveNudge" -->
        <!-- <div class="one3d-nudge bottom-right one3d-mobile-nudge">
          <p>Join <b>16,000+</b> others who've experienced test drives!</p>
          <img
            (click)="closeTestDriveNudge()"
            src="assets/img/icons/one3d-cross-icon-nudge.svg"
            alt="cross-icon"
          />
        </div> -->
      </ion-row>
    </ion-col>
  </ion-row>
  <!-- for cc -->
  <ion-row
    [hidden]="!showData"
    class="one3d-lhs-bottom-selected-mobile"
    *ngIf="globalService.getDeviceType() === 'mobile' && globalService.configurator"
  >
    <ion-col sizeXs="12" class="ion-no-padding">
      <div class="one3d-lhs-config-bottom-wrapper">
        <configurator-header></configurator-header>
        <div class="one3d-lhs-config-bottom-selected one3d-bg-dark-cc">
          <div class="one3d-lhs-config-bottom-details">
            <h4 class="one3d-lhs-config-bottom-title">
              <span class="one3d-variant-name-visualizer">
                {{globalService.selectedVariant?.variant_name}}
              </span>
              <!-- design view-breakup for idea 1,2,3 -->
              <span
                class="one3d-view-break-btn-new"
                *ngIf="globalService.idea != 0"
              >
                <img
                  src="assets/img/icons/one3d-vb-icon.svg"
                  alt="view-breakup"
                />
                <button
                  (click)="toggleBreakup()"
                  [disabled]="globalService.showLoadingPriceText"
                >
                  <span *ngIf="!viewBreakup"
                    >{{ globalService.showLoadingPriceText ? 'Loading Price' :
                    'View breakup' }}</span
                  >
                  <span *ngIf="viewBreakup">Hide Break-up</span>
                </button>
              </span>
            </h4>
            <p class="one3d-lhs-config-bottom-price">
              {{ globalService.currencyFormatter(
              globalService.selectedConfigPrice?.drive_away_price +
              accessoriesService.updateAccessoryPrice().packs)}}
              <span>Drive Away Price*</span>
            </p>
          </div>
          <!-- cc-1st-idea -->
          <div
            *ngIf="globalService.idea == 1"
            class="one3d-book-test-drive-btn-mobile one3d-rhs-header-btn one3d-shimmer-text"
          >
            <div
              class="one3d-book-test-drive-btn-mobile-box one3d-new-td-btn"
              (click)="testDrive()"
            >
              <div class="title">TEST DRIVE</div>
            </div>
          </div>
          <!-- cc-second-idea -->
          <div
            *ngIf="globalService.idea == 2 || globalService.idea == 4"
            class="one3d-book-test-drive-btn-mobile one3d-rhs-header-btn"
          >
            <div
              class="one3d-book-test-drive-btn-mobile-box one3d-new-td-btn one3d-test-drive-btn-only"
              (click)="testDrive()"
            >
              <div class="icon rotate">
                <img
                  src="assets/img/icons/one3d-test-drive-new-icon.svg"
                  alt="cross-icon"
                />
              </div>
              <div class="title">TEST DRIVE</div>
            </div>
            <!-- <div
              class="one3d-book-test-drive-btn-mobile-box one3d-new-td-btn"
              (click)="reserveVehicle()"
              *ngIf="globalService.model?.lms_integrated_code === 'JJ24'"
            >
              <div class="icon rotate">
                <img
                  src="assets/img/icons/one3d-test-drive-new-icon.svg"
                  alt="cross-icon"
                />
              </div>
              <div class="title">RESERVE VEHICLE</div>
            </div> -->
          </div>
          <div
            class="one3d-nudge top-right top-right-cc one3d-mobile-nudge"
            *ngIf="showTestDriveNudge"
          >
            <p>Join <b>16,000+</b> others who've experienced test drives!</p>
            <!-- <p *ngIf="globalService.model?.lms_integrated_code === 'JJ24'">Reserve your Jeep Avenger today</p> -->
            <img
              (click)="closeTestDriveNudge()"
              src="assets/img/icons/one3d-cross-icon-nudge.svg"
              alt="cross-icon"
            />
          </div>
          <!-- cc-old idea-0 -->
          <div
            class="one3d-lhs-config-bottom-btn"
            *ngIf="globalService.idea ==0"
          >
            <button
              (click)="toggleBreakup()"
              [disabled]="globalService.showLoadingPriceText"
            >
              <span *ngIf="!viewBreakup"
                >{{ globalService.showLoadingPriceText ? 'Loading Price' : 'View Break-up' }}</span
              >
              <span *ngIf="viewBreakup">Hide Break-up</span>
            </button>
          </div>
          <!-- download-icon in place of offer btn for idea 3 -->
          <div
            class="one3d-rhs-header-btn one3d-download-btn-mobile"
            *ngIf="globalService.idea == 3"
          >
            <div class="download-btn-icon" (click)="saveConfiguration()">
              <span
                ><img
                  src="assets/img/icons/one3d-download-new-icon.svg"
                  alt="download-icon"
              /></span>
            </div>
          </div>
        </div>
      </div>
    </ion-col>
  </ion-row>
  <!-- old-design-of-customize-bottom (download & summary btns)-->
  <ion-row
    [hidden]="!showData"
    class="one3d-lhs-bottom-selected-desktop"
    *ngIf="globalService.configurator"
  >
    <ion-col sizeXs="12" class="ion-no-padding">
      <div class="one3d-lhs-config-bottom-wrapper">
        <div *ngIf="!viewBreakup" class="one3d-lhs-config-bottom-selected">
          <div class="one3d-lhs-config-bottom-details">
            <h4 class="one3d-lhs-config-bottom-title">
              {{globalService.selectedVariant?.variant_name}}
            </h4>
            <p class="one3d-lhs-config-bottom-price">
              {{ globalService.currencyFormatter(
              globalService.selectedConfigPrice?.drive_away_price +
              accessoriesService.updateAccessoryPrice().packs)}}
              <span>Drive Away Price*</span>
            </p>
          </div>
          <div class="one3d-lhs-config-bottom-btn">
            <button
              (click)="toggleBreakup()"
              [disabled]="globalService.showLoadingPriceText"
            >
              {{ globalService.showLoadingPriceText ? 'Loading Price' : 'View Break-up' }}
            </button>
          </div>
          <div
            *ngIf="globalService.idea == 1"
            class="one3d-book-test-drive-btn-mobile one3d-rhs-header-btn one3d-shimmer-text"
          >
            <div
              class="one3d-book-test-drive-btn-mobile-box one3d-new-td-btn"
              (click)="testDrive()"
            >
              <div class="title">TEST DRIVE</div>
            </div>
          </div>
        </div>
        <div *ngIf="viewBreakup" class="one3d-config-breakup">
          <div class="one3d-config-breakup-top">
            <button
              (click)="toggleBreakup()"
              class="one3d-config-breakup-hide-btn"
            >
              Hide Break-up
            </button>
          </div>
          <summary-breakup [fromBreakup]="true"></summary-breakup>
        </div>
        <ion-row
          class="one3d-lhs-config-btn-row"
          *ngIf="globalService.idea != 3 || (globalService.idea == 3 && globalService.getDeviceType() !== 'mobile')"
        >
          <ion-col class="ion-no-padding col-6-remove-space" size="6">
            <ion-button
              class="one3d-lhs-config-btn one3d-lhs-config-left-btn"
              expand="full"
              fill="solid"
              (click)="saveConfiguration()"
              translate
            >
              DOWNLOAD
              <span>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </span>
            </ion-button>
          </ion-col>
          <ion-col class="ion-no-padding col-6-remove-space" size="6">
            <ion-button
              (click)="viewCart()"
              class="one3d-lhs-config-btn one3d-lhs-config-right-btn"
              expand="full"
            >
              SUMMARY
              <span>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </span>
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row
          class="one3d-lhs-config-btn-row"
          *ngIf="globalService.idea == 3 && globalService.getDeviceType() === 'mobile'"
        >
          <ion-col class="ion-no-padding col-6-remove-space" size="6">
            <ion-button
              class="one3d-lhs-config-btn one3d-lhs-config-left-btn"
              expand="full"
              fill="solid"
              (click)="viewCart()"
            >
              SUMMARY
              <span>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </span>
            </ion-button>
          </ion-col>
          <ion-col class="ion-no-padding col-6-remove-space" size="6">
            <ion-button
              (click)="testDrive()"
              class="one3d-lhs-config-btn one3d-lhs-config-right-btn"
              expand="full"
            >
              BOOK A TEST DRIVE
              <span>
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </span>
            </ion-button>
          </ion-col>
        </ion-row>
      </div>
    </ion-col>
  </ion-row>
  <div *ngIf="isDisplayTutorial">
    <!--Tap and drag to rotate starts here-->
    <div
      class="one3d-tutorial-new one3d-tutorial-tap-drag"
      *ngIf="tutorialType === tutorialTypes.Tap"
    >
      <div class="one3d-tap-drag">
        <div class="one3d-tap-drag-icon">
          <svg
            class="one3d-tutorial-tap-drag-svg"
            width="199"
            height="43"
            viewBox="0 0 199 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="one3d-tutorial-tap-drag-dash-line"
              opacity="0.6"
              d="M19 20.4004L97.077 20.9032L179 21.4309"
              stroke="white"
              stroke-width="3.3"
              stroke-dasharray="8 8"
            />
            <g
              class="one3d-tutorial-tap-drag-circle-border"
              filter="url(#filter0_b_1458_260)"
            >
              <rect
                x="8"
                y="5"
                width="33"
                height="33"
                rx="16.5"
                fill="white"
                fill-opacity="0.05"
              />
              <rect
                x="8.55"
                y="5.55"
                width="31.9"
                height="31.9"
                rx="15.95"
                stroke="white"
                stroke-width="1.1"
              />
            </g>
            <rect
              class="one3d-tutorial-tap-drag-circle"
              x="15.1465"
              y="12.1445"
              width="18.711"
              height="18.711"
              rx="9.3555"
              fill="white"
            />
            <defs>
              <filter
                id="filter0_b_1458_260"
                x="-3.88"
                y="-6.88"
                width="56.76"
                height="56.76"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.94" />
                <feComposite
                  in2="SourceAlpha"
                  operator="in"
                  result="effect1_backgroundBlur_1458_260"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_backgroundBlur_1458_260"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <p class="one3d-tap-drag-text">
          <strong class="one3d-tap-drag-strong">Tap and drag</strong> to rotate
        </p>
      </div>
    </div>
    <!--Tap and drag to rotate ends here-->
    <!--Pinch or scroll to zoom in & out starts here-->
    <div
      class="one3d-tutorial-new one3d-tutorial-pinch-scroll"
      *ngIf="tutorialType === tutorialTypes.Pinch"
    >
      <div class="one3d-pinch-scroll">
        <div class="one3d-pinch-scroll-icon">
          <svg
            class="one3d-pinch-scroll-svg"
            width="67"
            height="106"
            viewBox="0 0 67 106"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="one3d-pinch-scroll-up-arrow"
              d="M47.3496 31.2568L33.5996 17.5068L19.8496 31.2568"
              stroke="white"
              stroke-width="4.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              class="one3d-pinch-scroll-down-arrow"
              d="M19.8496 75.2568L33.5996 89.0068L47.3496 75.2568"
              stroke="white"
              stroke-width="4.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <p class="one3d-tap-drag-text">
          <strong class="one3d-tap-drag-strong">Pinch or scroll </strong> to
          zoom in & out
        </p>
      </div>
    </div>
    <!--Pinch or scroll to zoom in & out ends here-->
  </div>
</ion-content>
